"use strict";
import {tools} from "../tools.js";
import Collapsible from "./Collapsible";

class AnchorableCollapsible extends Collapsible {
    constructor(name='',
                wrapperElt=HTMLElement,
                btnsElt=HTMLCollection,
                collapsibleElt=HTMLElement,
                areaElt =HTMLElement
    ) {
        super(name, wrapperElt, btnsElt, collapsibleElt, areaElt);
    }


    init() {
        this.isAnchor = false;
        if(this.wrapper && this.btns && this.collapsible && this.area) {
            let url = new URL(window.location);
            let params = new URLSearchParams(url.search);
            if (params.get("to")){
                this.isAnchor = params.get("to") === encodeURIComponent(this.wrapper.id);
            }
            this.isOpen = this.wrapper.classList.contains(this.unfoldClass) || this.isAnchor;
        }

        super.init();

        if (this.isAnchor){
            tools.scrollToElt(window, this.wrapper, tools.isMobileNav() ? -150 : -190)
        }
    }

    getBtnClickAction() {
        return (e) => {
            super.getBtnClickAction()(e);
            let url = new URL(window.location);

            if (!this.isOpen){
                url.searchParams.delete("to");
            } else {
                url.searchParams.set("to", encodeURIComponent(this.wrapper.id.toString()));
            }
            window.history.pushState({}, this.name, url.href);

        }
    }
}

export default AnchorableCollapsible;
